import { Box, Typography, styled } from '@mui/material';
import { Authentication, useGetSettingsQuery } from '@vxui/common';
import { CustomerLogo, ModalContextProvider, PageErrorBoundary, StreamVX, TopBar, UserDetails } from '@vxui/components';
import { FC, Fragment } from 'react';
import { Link, Outlet } from 'react-router-dom';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100vw',
  height: '100vh',
}));

const Wrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: 'fit-content',
  flexGrow: 1,
  overflow: 'hidden',
  height: '100%',
}));

const Main = styled('main')(({ theme }) => ({
  overflow: 'auto',
  flexBasis: 'fit-content',
  flexGrow: 1,
  backgroundColor: theme.palette.primary[10],
  padding: '40px 80px',
}));

const Footer = styled(Box)(() => ({
  padding: '17px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#e6e6e6',
}));

export const App: FC = () => {
  const { data: settings } = useGetSettingsQuery();
  const isAuth = !!settings?.servers.serverAuth;
  const AuthComponent = isAuth ? Authentication : Fragment;

  return (
    <Container>
      <ModalContextProvider>
        {settings && (
          <AuthComponent>
            <Wrapper>
              <TopBar sx={{ justifyContent: 'space-between', bgcolor: 'primary.main' }}>
                <Link to="/">
                  {__APP_STYLE__ === 'customer' ? (
                    <CustomerLogo className="Navigation-customerLogo" />
                  ) : (
                    <StreamVX className="Navigation-logo" height="20px" width="180px" color="#fff" />
                  )}
                </Link>
                {isAuth && <UserDetails sx={{ '.MuiBox-root:first-of-type': { filter: 'invert(1)' } }} />}
              </TopBar>
              <Main>
                <PageErrorBoundary>
                  <Outlet />
                </PageErrorBoundary>
              </Main>
              {__APP_STYLE__ === 'customer' && (
                <Footer bgcolor="primary.20">
                  <Typography variant="p16Medium" marginTop="2px" color="primary.70">
                    POWERED BY
                  </Typography>
                  <StreamVX
                    className="Navigation-logo"
                    height="16px"
                    width="120px"
                    color="#46535D"
                    filter="grayscale(1)"
                  />
                </Footer>
              )}
            </Wrapper>
          </AuthComponent>
        )}
      </ModalContextProvider>
    </Container>
  );
};
